<template>
  <div class="calciatore-su-tavolo-container" v-if="Calciatore">
    <div class="calciatore-su-tavolo-img">
      <div class="imgCalciatore without-ms">
        <div class="imgContainer imgContainer-ruolo_">
          <div
            v-if="Config.AVATAR_OR_FLAG == 'avatar'"
            class="img"
            :key="Calciatore.nid"
            :style="{
              backgroundImage: `url(${
                Calciatore.imgCalciatore
                  ? Calciatore.imgCalciatore
                  : Config.PUBLIC_DIR +
                    '/schede_calciatori/avatar/default/avatar_club_' +
                    Calciatore.ID_Club +
                    '.png'
              })`,
            }"
          ></div>
          <div
            v-if="Config.AVATAR_OR_FLAG == 'flag'"
            class="img flag"
            :key="Calciatore.nid"
            :style="{
              backgroundImage: `url(${
                Config.PUBLIC_DIR +
                '/clubs/flags/flag_' +
                Calciatore.ID_Club +
                '.png'
              })`,
            }"
          ></div>
        </div>
      </div>
    </div>

    <div class="calciatore-su-tavolo-nomeCalciatore">
      <span :class="['Ruolo', 'Ruolo_' + Calciatore.ID_Ruolo]">{{
        ruolo(Calciatore.ID_Ruolo)
      }}</span>
      {{ Calciatore.calciatore }}
    </div>

    <span class="calciatore-su-tavolo-nomeClub ellipsis">{{
      Calciatore.nomeClub
    }}</span>

  </div>
</template>

<script>
import Vuex from "vuex";

import al from "../../js/db";
import mixins from "../../js/mixins";
import Config from "../../../config-app/config";

export default {
  name: "calciatore-su-tavolo",
  mixins: [mixins],
  props: {
    id: {
      type: String,
      required: true,
    },
    clicked: {
      type: Function,
      default: function () {},
    },
  },
  mounted() {},
  computed: {
    Calciatore() {
      return this.calciatori[this.id];
    },
    ...Vuex.mapGetters(["calciatori"]),
  },
};
</script>
<style lang="scss" scoped>
.calciatore-su-tavolo-container {
  color: #ffffff;
  font-family: roboto;
  position: absolute;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 170px;
  background: rgb(0 0 0 / 20%);
  height: 125px;
  border-radius: 15px;
  .Ruolo {
    margin-right: 5px;
    /* position: absolute; */
    /* left: 10px; */
    box-shadow: 0px 1px 10px 3px rgb(0 0 0 / 12%);
  }

  .calciatore-su-tavolo-img {
    .imgCalciatore {
      width: 60px;
      height: 65px;
      .imgContainer {
        background-color: transparent;
        box-shadow: none;
        border-radius: 0;
        .img {
          width: 60px;
          height: 65px;
          &.flag {
            height: 55px;
            width: 55px;
            margin: 0;
          }
        }
      }
    }
  }

  .calciatore-su-tavolo-nomeCalciatore {
    font-weight: bold;
    background: rgb(0 0 0 / 50%);
    padding: 5px 7px;
    border-radius: 100px;
    display: flex;
    align-items: center;
    max-width: 140px;
    overflow: hidden;
    justify-content: center;
  }
  .calciatore-su-tavolo-nomeClub {
    color: rgb(0 0 0 / 50%);
    font-weight: bold;
  }
}
</style>
